import { MicrophoneIcon, PauseIcon, PlayIcon, StopIcon, XMarkIcon } from "@heroicons/react/24/outline";

const VoiceRecordingControls = ({ 
  isRecording, 
  isPaused, 
  recordingTime, 
  onStartRecording, 
  onPauseRecording, 
  onResumeRecording, 
  onStopRecording, 
  onCancelRecording 
}) => {
  const formatRecordingTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  return (
    <>
      {/* Voice Recording Start Button */}
      {!isRecording && (
        <button
          onClick={onStartRecording}
          className="p-3 rounded-lg bg-[#128C7E]/10 hover:bg-[#128C7E]/20 dark:bg-[#25D366]/10 dark:hover:bg-[#25D366]/20 text-[#128C7E] dark:text-[#25D366] transition-colors border border-[#128C7E]/30 dark:border-[#25D366]/30"
          title="Record voice message"
        >
          <MicrophoneIcon className="w-5 h-5" />
        </button>
      )}

      {/* Recording Active Controls */}
      {isRecording && (
        <div className="flex items-center gap-2 flex-1 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded-lg px-3 py-2">
          {/* Recording Indicator */}
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-red-600 dark:text-red-400">
              {formatRecordingTime(recordingTime)}
            </span>
          </div>
          
          {/* Paused Indicator */}
          {isPaused && (
            <span className="text-xs text-orange-600 dark:text-orange-400">
              (Paused)
            </span>
          )}
          
          <div className="flex-1"></div>
          
          {/* Control Buttons */}
          <div className="flex items-center gap-1">
            {!isPaused ? (
              <button
                onClick={onPauseRecording}
                className="p-1.5 hover:bg-red-100 dark:hover:bg-red-900/30 rounded transition-colors"
                title="Pause recording"
              >
                <PauseIcon className="w-4 h-4 text-red-600 dark:text-red-400" />
              </button>
            ) : (
              <button
                onClick={onResumeRecording}
                className="p-1.5 hover:bg-green-100 dark:hover:bg-green-900/30 rounded transition-colors"
                title="Resume recording"
              >
                <PlayIcon className="w-4 h-4 text-green-600 dark:text-green-400" />
              </button>
            )}
            <button
              onClick={onStopRecording}
              className="p-1.5 hover:bg-green-100 dark:hover:bg-green-900/30 rounded transition-colors"
              title="Stop & Save"
            >
              <StopIcon className="w-4 h-4 text-green-600 dark:text-green-400" />
            </button>
            <button
              onClick={onCancelRecording}
              className="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
              title="Cancel recording"
            >
              <XMarkIcon className="w-4 h-4 text-gray-600 dark:text-gray-400" />
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default VoiceRecordingControls

